const libOptions=[
    {
        "label": "Software Architecture",
        "value": "software-architecture"
    },
    {
        "label": "System Design Components",
        "value": "system-design"
    },
    {
        "label": "Architecture diagram components",
        "value": "architecture-diagram-components"
    },
    {
        "label": "Software Logos",
        "value": "drwnio"
    },
    {
        "label": "Stick Figures",
        "value": "stick-figures"
    },
    {
        "label": "Forms",
        "value": "forms"
    },
    {
        "label": "AWS Architecture Icons",
        "value": "aws-architecture-icons"
    },
    {
        "label": "Data Viz",
        "value": "data-viz"
    },
    {
        "label": "Awesome Icons",
        "value": "awesome-icons"
    },
    {
        "label": "Cloud",
        "value": "cloud"
    },
    {
        "label": "Decision flow control",
        "value": "decision-flow-control"
    },
    {
        "label": "Basic UX/wireframing elements",
        "value": "basic-ux-wireframing-elements"
    },
    {
        "label": "System Design Template",
        "value": "system-design-template"
    },
    {
        "label": "Google Icons",
        "value": "google-icons"
    },
    {
        "label": "Icons",
        "value": "icons"
    },
    {
        "label": "Systems Design Components",
        "value": "systems-design-components"
    },
    {
        "label": "Dev Ops Icons",
        "value": "dev_ops"
    },
    {
        "label": "Network topology icons",
        "value": "network-topology-icons"
    },
    {
        "label": "Database",
        "value": "db-eng"
    },
    {
        "label": "Algorithms and Data Structures (Arrays, Matrices, Trees ...)",
        "value": "algorithms-and-data-structures-arrays-matrices-trees"
    },
    {
        "label": "Lo-Fi Wireframing Kit",
        "value": "lo-fi-wireframing-kit"
    },
    {
        "label": "Technology Logos",
        "value": "technology-logos"
    },
    {
        "label": "Sticky Notes",
        "value": "post-it"
    },
    {
        "label": "Cloud Design Patterns",
        "value": "cloud-design-patterns"
    },
    {
        "label": "Basic shapes",
        "value": "basic-shapes"
    },
    {
        "label": "Bubbles",
        "value": "bubbles"
    },
    {
        "label": "Web Kit",
        "value": "web-kit"
    },
    {
        "label": "Information Architecture",
        "value": "information-architecture"
    },
    {
        "label": "Storytelling",
        "value": "storytelling"
    },
    {
        "label": "Computers",
        "value": "computers"
    },
    {
        "label": "IT Logos",
        "value": "it-logos"
    },
    {
        "label": "AWS Serverless Icons",
        "value": "aws-serverless"
    },
    {
        "label": "Gantt Diagram",
        "value": "gantt"
    },
    {
        "label": "Microsoft Azure cloud icons",
        "value": "microsoft-azure-cloud-icons"
    },
    {
        "label": "Azure cloud services icons",
        "value": "azure-cloud-services"
    },
    {
        "label": "Artem's icons",
        "value": "artem-s-icons"
    },
    {
        "label": "Data Platform",
        "value": "data-platform"
    },
    {
        "label": "some-handdrawn-signs",
        "value": "some-handdrawn-signs"
    },
    {
        "label": "Emojis",
        "value": "emojis"
    },
    {
        "label": "Data sources",
        "value": "data-sources"
    },
    {
        "label": "Universal UI kit",
        "value": "universal-ui-kit"
    },
    {
        "label": "Robots",
        "value": "robots"
    },
    {
        "label": "AWS Simple Icons",
        "value": "aws-simple-icons"
    },
    {
        "label": "System Icons",
        "value": "system-icons"
    },
    {
        "label": "Math Teacher Library",
        "value": "math-teacher-library"
    },
    {
        "label": "Hexagonal Architecture",
        "value": "hexagonal-architecture"
    },
    {
        "label": "Webpage frames",
        "value": "webpage-frames"
    },
    {
        "label": "Dropdowns",
        "value": "dropdowns"
    },
    {
        "label": "Charts",
        "value": "charts"
    },
    {
        "label": "GCP Icons",
        "value": "gcp-icons"
    },
    {
        "label": "Azure Network",
        "value": "azure-network"
    },
    {
        "label": "Apple Devices Frames",
        "value": "apple-devices-frames"
    },
    {
        "label": "Graphs",
        "value": "graphs"
    },
    {
        "label": "Stick people",
        "value": "stick-people"
    },
    {
        "label": "Gadgets",
        "value": "gadgets"
    },
    {
        "label": "System Design Icons",
        "value": "systemdesignicons"
    },
    {
        "label": "Mobile Kit",
        "value": "mobile-kit"
    },
    {
        "label": "Wardley Maps Symbols",
        "value": "wardley-maps-symbols"
    },
    {
        "label": "Original Google Architecture Icons",
        "value": "original-google-architecture-icons"
    },
    {
        "label": "Deep learning",
        "value": "deep-learning"
    },
    {
        "label": "Scrum board",
        "value": "scrum-board"
    },
    {
        "label": "Network elements",
        "value": "network-elements"
    },
    {
        "label": "Some more logos",
        "value": "logos"
    },
    {
        "label": "Polygons",
        "value": "polygons"
    },
    {
        "label": "AWS Architecture Icons",
        "value": "aws-architecture-icons"
    },
    {
        "label": "Schematic Symbols",
        "value": "schematic-symbols"
    },
    {
        "label": "IT Logos",
        "value": "it-logos"
    },
    {
        "label": "Medias",
        "value": "medias"
    },
    {
        "label": "Mathematical Symbols",
        "value": "mathematical-symbols"
    },
    {
        "label": "Awesome Slides",
        "value": "awesome-slides"
    },
    {
        "label": "Data processing",
        "value": "data-processing"
    },
    {
        "label": "HTML input elements",
        "value": "html-input-elements"
    },
    {
        "label": "Business Model Templates",
        "value": "canvases"
    },
    {
        "label": "Veeam",
        "value": "veeam"
    },
    {
        "label": "Wardley Mapping Canvas",
        "value": "wardley-mapping-canvas"
    },
    {
        "label": "UML Library: Activity Diagram",
        "value": "uml-library-activity-diagram"
    },
    {
        "label": "Data Science logos",
        "value": "data-science"
    },
    {
        "label": "VMware Architecture Design",
        "value": "vmware-architecture-design"
    },
    {
        "label": "GitHub Git Icons",
        "value": "github-icons"
    },
    {
        "label": "Message Queue components",
        "value": "mq"
    },
    {
        "label": "Presentation Templates",
        "value": "presentation-templates"
    },
    {
        "label": "Redis Grafana",
        "value": "redis-grafana"
    },
    {
        "label": "Office Items",
        "value": "office-items"
    },
    {
        "label": "Azure Compute",
        "value": "azure-compute"
    },
    {
        "label": "bpmn",
        "value": "bpmn"
    },
    {
        "label": "Microsoft 365 icons",
        "value": "microsoft-365-icons"
    },
    {
        "label": "Some common cloud apps",
        "value": "some-common-cloud-apps"
    },
    {
        "label": "Network locations",
        "value": "network-locations"
    },
    {
        "label": "Snowflake Iconography",
        "value": "snowflake-iconography"
    },
    {
        "label": "Azure General",
        "value": "azure-general"
    },
    {
        "label": "Simple Sticky Notes",
        "value": "simple-sticky-notes"
    },
    {
        "label": "Hearts",
        "value": "hearts"
    },
    {
        "label": "C4 Architecture",
        "value": "c4-architecture"
    },
    {
        "label": "Common Home Network Basics",
        "value": "common-home-network-basics"
    },
    {
        "label": "Kubernetes Icons Set",
        "value": "kubernetes-icons-set"
    },
    {
        "label": "Stars",
        "value": "stars"
    },
    {
        "label": "Veeam unofficial",
        "value": "veeam_unofficial"
    },
    {
        "label": "Customer Journey Map",
        "value": "customer-journey-map"
    },
    {
        "label": "2022 - GANTT",
        "value": "2022-gantt"
    },
    {
        "label": "Clouds",
        "value": "clouds"
    },
    {
        "label": "Data Flow",
        "value": "data-flow"
    },
    {
        "label": "Android",
        "value": "android"
    },
    {
        "label": "Misc Azure Icons",
        "value": "misc-azure-icons"
    },
    {
        "label": "Cryptocurrencies",
        "value": "cryptocurrencies"
    },
    {
        "label": "Microsoft Apps",
        "value": "microsoft-apps"
    },
    {
        "label": "Maps",
        "value": "maps"
    },
    {
        "label": "Make your calendar",
        "value": "make-your-calendar"
    },
    {
        "label": "Clocks",
        "value": "clocks"
    },
    {
        "label": "3D Shapes",
        "value": "3d-shapes"
    },
    {
        "label": "AWS Serverless Icons v2",
        "value": "aws-serverless-icons-v2"
    },
    {
        "label": "Snowflake datawarehousing Icons",
        "value": "snowflake"
    },
    {
        "label": "DnD 5e planning",
        "value": "dnd-writing-icons-for-dm"
    },
    {
        "label": "Medicine",
        "value": "medicine"
    },
    {
        "label": "Azure Storage",
        "value": "azure-storage"
    },
    {
        "label": "Front End Tools & Technologies",
        "value": "front-end-tech-and-tools"
    },
    {
        "label": "Baby Characters",
        "value": "baby-characters"
    },
    {
        "label": "Enterprise Integration Patterns",
        "value": "enterprise-integration-patterns"
    },
    {
        "label": "Wireframing placeholders",
        "value": "wireframing-placeholders"
    },
    {
        "label": "Team Topologies",
        "value": "team-topologies"
    },
    {
        "label": "Coordinates",
        "value": "coordinates"
    },
    {
        "label": "Comms Platform Icons",
        "value": "comms-platform-icons"
    },
    {
        "label": "Desktop Resolutions",
        "value": "desktop-resolutions"
    },
    {
        "label": "Biology",
        "value": "biology"
    },
    {
        "label": "NSX-T VMware",
        "value": "nsx-t-vmware"
    },
    {
        "label": "Computer parts",
        "value": "computer-parts"
    },
    {
        "label": "Despair",
        "value": "despair"
    },
    {
        "label": "Banners",
        "value": "banners"
    },
    {
        "label": "Arduino Boards",
        "value": "arduino-boards"
    },
    {
        "label": "HTML, CSS and JS logos",
        "value": "html-css-js-icons"
    },
    {
        "label": "Kubernetes icons",
        "value": "kubernetes-icons"
    },
    {
        "label": "Azure Containers",
        "value": "azure-containers"
    },
    {
        "label": "Circuit Components",
        "value": "circuit-components"
    },
    {
        "label": "science chemistry gcse",
        "value": "science-chemistry-gcse"
    },
    {
        "label": "Data Vault",
        "value": "data-vault"
    },
    {
        "label": "Electrical Engineering",
        "value": "electrical-engineering"
    },
    {
        "label": "Raspberry Pi 3",
        "value": "raspberrypi3"
    },
    {
        "label": "Stick Figures Collaboration",
        "value": "stick-figures-collaboration"
    },
    {
        "label": "Organization Chart",
        "value": "organization-chart"
    },
    {
        "label": "Domain-Driven Design",
        "value": "domain-driven-design"
    },
    {
        "label": "Periodic Table",
        "value": "periodic-table"
    },
    {
        "label": "Chess set",
        "value": "chess-set"
    },
    {
        "label": "Retail peripherals",
        "value": "retail-peripherals"
    },
    {
        "label": "ELK Stack",
        "value": "elk-stack"
    },
    {
        "label": "Raspberry Pi Zero",
        "value": "raspberrypi-zero"
    },
    {
        "label": "Golang gophers",
        "value": "golang-gophers"
    },
    {
        "label": "Halloween elements",
        "value": "halloween-elements"
    },
    {
        "label": "Digital Signal Processing",
        "value": "digital-signal-processing"
    },
    {
        "label": "Web3 Crypto Solution Design v1",
        "value": "web3-crypto-solution-design-v1"
    },
    {
        "label": "code-essentials",
        "value": "code-essentials"
    },
    {
        "label": "Event Storming",
        "value": "event-storming"
    },
    {
        "label": "secure_shell",
        "value": "secure_shell"
    },
    {
        "label": "Racks and Servers / Components",
        "value": "racks-and-servers-components"
    },
    {
        "label": "Music notation",
        "value": "music-notation"
    },
    {
        "label": "Football Icons",
        "value": "football-icons"
    },
    {
        "label": "DS visualizations",
        "value": "ds-visualizations"
    },
    {
        "label": "Valentine's Day",
        "value": "valentine-s-day"
    },
    {
        "label": "IT Tools Logos",
        "value": "it-tools-logos"
    },
    {
        "label": "Playing cards",
        "value": "playing-cards"
    },
    {
        "label": "Organic Chemistry Basics",
        "value": "organic-chemistry-basics"
    },
    {
        "label": "Red Hat",
        "value": "red-hat"
    },
    {
        "label": "3d coordinate systems + graphs",
        "value": "3d-coordinate-systems-graphs"
    },
    {
        "label": "Boardgame",
        "value": "boardgame"
    },
    {
        "label": "Barotrauma",
        "value": "barotrauma"
    },
    {
        "label": "Music Instruments",
        "value": "music-instruments"
    },
    {
        "label": "Go Icons",
        "value": "go-icons"
    },
    {
        "label": "Internet Service providers",
        "value": "internet-service-providers"
    },
    {
        "label": "Common Screen Resolutions",
        "value": "common-screen-resolutions"
    },
    {
        "label": "PRINTERS",
        "value": "printers"
    },
    {
        "label": "Arduino Micro",
        "value": "arduino-micro"
    },
    {
        "label": "Risk based Test Strategy",
        "value": "risk-based-test-strategy"
    },
    {
        "label": "Male Heads Diverse 1",
        "value": "male-heads-diverse-1"
    },
    {
        "label": "Dart and Flutter icons",
        "value": "dart-and-flutter-icons"
    },
    {
        "label": "Head Builder Kit 1",
        "value": "head-builder-kit-1"
    },
    {
        "label": "R Icons",
        "value": "r"
    },
    {
        "label": "Tools",
        "value": "tools"
    },
    {
        "label": "Macroeconomics",
        "value": "macroeconomics"
    },
    {
        "label": "Fibre Network",
        "value": "fibre-network"
    },
    {
        "label": "Traffic signs ⛔🛑",
        "value": "traffic-signs"
    },
    {
        "label": "Picasso's Line Drawings",
        "value": "picasso-s-line-drawings"
    },
    {
        "label": "Genealogy Essentials",
        "value": "genealogy-essentials"
    },
    {
        "label": "TTRPG Clocks",
        "value": "ttrpg-clocks"
    },
    {
        "label": "Synths and FX",
        "value": "synths-and-fx"
    },
    {
        "label": "micro",
        "value": "micro"
    },
    {
        "label": "logic gates",
        "value": "logic-gates"
    },
    {
        "label": "Body Builder Kit 1",
        "value": "body-builder-kit-1"
    },
    {
        "label": "Types and Values in JavaScript",
        "value": "types-and-values-in-javascript"
    },
    {
        "label": "Montessori Basic Grammar Symbols",
        "value": "montessori-basic-grammar-symbols"
    },
    {
        "label": "Character Kit 1",
        "value": "character-kit-1"
    },
    {
        "label": "Ultimate Frisbee",
        "value": "ultimate-frisbee"
    },
    {
        "label": "Female Heads Diverse",
        "value": "female-heads-diverse"
    },
    {
        "label": "Architecture floor plan symbols",
        "value": "architecture"
    },
    {
        "label": "Random figure drawings",
        "value": "random-figure-drawings"
    },
    {
        "label": "Shapes for UML & ER Diagrams",
        "value": "UML-ER-library"
    },
    {
        "label": "Yellow box",
        "value": "yellow-box"
    },
    {
        "label": "Logic Gates",
        "value": "Logic-Gates"
    }
];

export default libOptions;
